import { render, staticRenderFns } from "./SalarySlipSanjivaniPrint.vue?vue&type=template&id=5ea24df8&scoped=true&style=background-color%3A%20white%3B&"
import script from "./SalarySlipSanjivaniPrint.vue?vue&type=script&lang=js&"
export * from "./SalarySlipSanjivaniPrint.vue?vue&type=script&lang=js&"
import style0 from "./SalarySlipSanjivaniPrint.vue?vue&type=style&index=0&id=5ea24df8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea24df8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VBtn,VCard,VCol,VContainer,VIcon,VRow,VSnackbar})
